import { NgModule, Pipe } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class WordsPipe {
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    transform(value, args = 4) {
        let /** @type {?} */ res = value;
        if (value && args > 0) {
            const /** @type {?} */ valueWords = value.split(/\s+/);
            if (valueWords.length > args) {
                res = valueWords.slice(0, args).join(' ') + '…';
            }
        }
        return res;
    }
}
WordsPipe.ɵfac = function WordsPipe_Factory(t) { return new (t || WordsPipe)(); };
WordsPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "words", type: WordsPipe, pure: true });
/**
 * @nocollapse
 */
WordsPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WordsPipe, [{
        type: Pipe,
        args: [{
                name: 'words'
            }]
    }], null, null); })();

class SplitcharactersPipe {
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    transform(value, args = 10) {
        let /** @type {?} */ res = value;
        if (value && value.length > args && args > 0) {
            const /** @type {?} */ prefix = value.substring(0, args / 2);
            const /** @type {?} */ postfix = value.substring(value.length - args / 2, value.length);
            res = `${prefix}...${postfix}`;
        }
        return res;
    }
}
SplitcharactersPipe.ɵfac = function SplitcharactersPipe_Factory(t) { return new (t || SplitcharactersPipe)(); };
SplitcharactersPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "splitcharacters", type: SplitcharactersPipe, pure: true });
/**
 * @nocollapse
 */
SplitcharactersPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitcharactersPipe, [{
        type: Pipe,
        args: [{
                name: 'splitcharacters'
            }]
    }], null, null); })();

class CharactersPipe {
    /**
     * @param {?} value
     * @param {?=} args
     * @param {?=} breakOnWord
     * @return {?}
     */
    transform(value, args = 10, breakOnWord) {
        let /** @type {?} */ res = value;
        if (value && value.length > args && args > 0) {
            value = value.substring(0, args);
            if (breakOnWord) {
                while (value.charAt(value.length - 1) === ' ') {
                    value = value.substr(0, value.length - 1);
                }
            }
            else {
                const /** @type {?} */ lastspace = value.lastIndexOf(' ');
                // get last space
                if (lastspace !== -1) {
                    value = value.substr(0, lastspace);
                }
            }
            res = `${value}...`;
        }
        return res;
    }
}
CharactersPipe.ɵfac = function CharactersPipe_Factory(t) { return new (t || CharactersPipe)(); };
CharactersPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "characters", type: CharactersPipe, pure: true });
/**
 * @nocollapse
 */
CharactersPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CharactersPipe, [{
        type: Pipe,
        args: [{
                name: 'characters'
            }]
    }], null, null); })();

class TruncatePipesModule {
    /**
     * Use in AppModule
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: TruncatePipesModule,
            providers: []
        };
    }
    /**
     * Use in features modules with lazy loading
     * @return {?}
     */
    static forChild() {
        return {
            ngModule: TruncatePipesModule,
            providers: []
        };
    }
}
TruncatePipesModule.ɵfac = function TruncatePipesModule_Factory(t) { return new (t || TruncatePipesModule)(); };
TruncatePipesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TruncatePipesModule });
TruncatePipesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
/**
 * @nocollapse
 */
TruncatePipesModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TruncatePipesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CharactersPipe,
                    SplitcharactersPipe,
                    WordsPipe
                    // Pipes.
                    // Directives.
                ],
                exports: [
                    CharactersPipe,
                    SplitcharactersPipe,
                    WordsPipe
                    // Pipes.
                    // Directives.
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TruncatePipesModule, { declarations: [CharactersPipe, SplitcharactersPipe, WordsPipe], exports: [CharactersPipe, SplitcharactersPipe, WordsPipe] }); })();

// Public classes.

/**
 * Angular library starter.
 * Build an Angular library compatible with AoT compilation & Tree shaking.
 * Written by Roberto Simonetti.
 * MIT license.
 * https://github.com/robisim74/angular-truncate-pipes
 */
/**
 * Entry point for all public APIs of the package.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TruncatePipesModule, CharactersPipe as ɵa, SplitcharactersPipe as ɵb, WordsPipe as ɵc };

